class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.quantity = parseInt(this.dataset.quantity) || 1;
    this.line = this.dataset.line;
    this.variantId = this.dataset.variantId;

    // Initialize after the element is fully rendered
    requestAnimationFrame(() => {
      this.initializeElements();
      this.setupEventListeners();
      this.validateInput();
    });
  }

  initializeElements() {
    this.input = this.querySelector('[data-quantity-input]');
    this.minusButton = this.querySelector('[data-quantity-minus]');
    this.plusButton = this.querySelector('[data-quantity-plus]');
  }

  setupEventListeners() {
    if (this.minusButton) {
      this.minusButton.addEventListener('click', () => this.updateQuantity(-1));
    }
    if (this.plusButton) {
      this.plusButton.addEventListener('click', () => this.updateQuantity(1));
    }
    if (this.input) {
      this.input.addEventListener('change', () => this.validateInput());
      this.input.addEventListener('input', () => this.validateInput());
      this.input.addEventListener('blur', () => {
        const value = parseInt(this.input.value);
        if (isNaN(value) || value < 1) {
          this.input.value = 1;
        }
        this.updateQuantity(0); // Update with the current input value
      });
    }
  }

  updateQuantity(change) {
    const currentValue = parseInt(this.input.value);
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const isDecreasingFromOne = currentValue === 1 && change < 0;

    console.log('Quantity Update:', {
      currentValue,
      change,
      isDecreasingFromOne,
      cartItemsFound: !!cartItems,
    });

    // Allow going to 0 if we're decreasing from 1, otherwise minimum is 1
    const newValue = isDecreasingFromOne ? 0 : Math.max(1, currentValue + change);

    this.input.value = newValue;
    this.validateInput();

    if (cartItems) {
      cartItems.updateQuantity(this.line, newValue, 'updates[]', this.variantId);
    }
  }

  validateInput() {
    const value = parseInt(this.input.value);
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const maxQuantity = parseInt(this.dataset.maxQuantity);

    if (isNaN(value) || value < 0) {
      this.input.value = '';
    }

    this.quantity = parseInt(this.input.value) || 1;

    if (maxQuantity && this.quantity > maxQuantity) {
      this.input.value = maxQuantity;
    }
  }
}

// Only define the custom element if it hasn't been defined yet
if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}
